module.exports = __webpack_public_path__ + "static/media/logout_dropdown.18be6418.svg";